import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";

import { displayData } from "../../../utils/data";
import { formatChrono } from "../../../utils/date";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  sectionContainer: {
    border: `1px solid ${colors.veryLighPink}`,
    borderRadius: "6px",
    padding: "8px",
  },
  section: {
    margin: "10px",
  },
};

const HspKioskMetrics = (props) => {
  const { classes, data } = props;

  return (
    <DashboardCard
      title={I18n.get("dashboard_kioskMetrics")}
      size={null}
      topNode={
        <Grid container style={{ marginLeft: "50px" }}>
          <Grid
            item
            style={{
              //color: colors.primary,
              color: colors.black87,
              fontWeight: 500,
              fontSize: "1.142em",
            }}
          >
            {displayData(get(data, ["kioskprofile", "total"]))}
          </Grid>
          <Grid
            item
            style={{
              marginLeft: "10px",
              color: colors.black54,
              fontSize: "1.142em",
            }}
          >
            {I18n.get("dashboard_kioskVisits")}
          </Grid>
        </Grid>
      }
    >
      <Grid container /*alignItems="flex-start" style={{ height: "100%" }}*/>
        <Section
          classes={classes}
          title={I18n.get("dashboard_humanIdentification")}
        >
          <Metric
            title={I18n.get("dashboard_faceRecognized")}
            icon={images.faceRecognized}
            value={get(data, ["kioskprofile", "details", "fr"])}
          />
          <Metric
            title={I18n.get("site_barcode")}
            icon={images.barcodeIconGrey}
            value={get(data, ["kioskprofile", "details", "barcode"])}
          />
          <Metric
            title={I18n.get("site_unknown")}
            icon={images.unknownIconGrey}
            value={get(data, ["kioskprofile", "details", "unknown"])}
          />
        </Section>
        <Section classes={classes} title={I18n.get("site_temperatures")}>
          <Metric
            title={I18n.get("site_temperatureReadings")}
            icon={images.temperatureIconGrey}
            value={get(data, ["kioskthermal", "total"])}
            style={{ maxWidth: "180px" }}
          />
          <Metric
            title={I18n.get("dashboard_feverDetected")}
            value={get(data, ["kioskthermal", "feverdetection"])}
            style={{ maxWidth: "160px" }}
          />
        </Section>
        <Section classes={classes} title={I18n.get("dashboard_averageTime")}>
          <Metric
            title={I18n.get("dashboard_averageTimeAtKiosk")}
            icon={images.averageTime}
            value={
              get(data, ["kioskaveragesurveytime"])
                ? formatChrono(
                    new Date(
                      Math.round(get(data, ["kioskaveragesurveytime"])) * 1000
                    ),
                    "mm:ss"
                  )
                : null
            }
            style={{
              maxWidth: "230px",
            }}
          />
        </Section>
      </Grid>
    </DashboardCard>
  );
};

const Section = (props) => {
  const { classes, title } = props;
  return (
    <Grid item className={classes.section}>
      <Grid container direction="column">
        <Grid item className="text-54">
          {title}
        </Grid>
        <Grid item className={classes.sectionContainer}>
          <Grid container justify="center">
            {props.children}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const Metric = (props) => {
  const { title, icon, value } = props;
  return (
    <Grid item style={{ padding: "0px 30px", ...props.style }}>
      <Grid container direction="column">
        <Grid
          item
          className="flexCenter text-87 bold-500"
          style={{
            marginBottom: "10px",
            lineHeight: "16px",
            minHeight: "32px",
          }}
        >
          {title}
        </Grid>
        <Grid item>
          <Grid container alignItems="center" style={{ height: "50px" }}>
            {icon && (
              <Grid item className="flexCenter">
                <img
                  src={icon}
                  style={{ height: "50px", maxWidth: "60px" }}
                  alt="icon"
                />
              </Grid>
            )}
            <Grid
              item
              xs
              style={{
                //color: colors.primary,
                color: colors.black87,
                fontWeight: 500,
                fontSize: "2em",
                marginLeft: icon ? "20px" : "0px",
                textAlign: icon ? "left" : "center",
              }}
            >
              {displayData(value)}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(HspKioskMetrics);
